/**
 * Groups/Lines Page
 */

import { Tags } from 'lucide-react'
import { CatalogPage } from './CatalogPage'
import { useTranslation } from '@/hooks/useTranslation'

export function GroupsPage() {
  const { t } = useTranslation()

  return (
    <CatalogPage
      icon={Tags}
      config={{
        endpoint: 'groups',
        basePath: '/groups',
        title: t('catalogs.groups'),
        newItemLabel: t('catalogs.newGroup'),
        noItemsLabel: t('catalogs.noGroups'),
        displayField: 'description',
        secondaryField: 'code',
        columns: [
          { key: 'code', header: t('articles.code') },
          { key: 'description', header: t('articles.description') },
        ],
      }}
    />
  )
}
